// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkCard-cls1_jew","cls2":"WorkCard-cls2_QCG WorkCard-cls1_jew"};